import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import { ParallaxProvider } from 'react-scroll-parallax';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './css/font-awesome.min.css';
import './css/themify-icons.css';
import './css/animate.css';
import './css/flaticon_medically.css';
import './sass/style.scss';
import { HelmetProvider } from 'react-helmet-async';

import { PersistGate } from "redux-persist/integration/react";
// import { store, persistor } from "./store/index";
import { Provider } from "react-redux";

// 👉 Import Tag Manager
import TagManager from 'react-gtm-module';

// 👉 Initialize GTM
const tagManagerArgs = {
    gtmId: 'GTM-KMV99W7F'  // <-- YOUR GTM ID
};
TagManager.initialize(tagManagerArgs);

// 👉 Then render App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <Provider store={store}>
    // <PersistGate loading={null} persistor={persistor}>
    <ParallaxProvider>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </ParallaxProvider>
    // </PersistGate>
    // </Provider >
);

// Track Web Vitals if needed
reportWebVitals();
